import { ErrorState } from '../Store/Error/state';
import { RootState } from '../Store';
import { useSelector } from 'react-redux';

const useGetError = (): Error | null => {
    const { error } = useSelector<RootState, ErrorState>(state => state.error);

    return error;
};

export default useGetError;
